import { gql } from '__generated__';

export const GET_CAMPAIGN = gql(/* GraphQL */ `
  query getCampaign($id: Int!) {
    campaign(id: $id) {
      ...AdminCampaignEditor
      ...CampaignOption
      id
      name
      dealName
      startDate
      endDate
      archived
      measurementUnits
      enableDocumentSystem
      pillarScoreDashboard
      reportScoreDashboard
      showReportScores
      currency
      measurementUnits
      tags {
        id
        name
        displayColour
        archived
      }
    }
  }
`);
